export enum Subject {
    UserDeleted = 'user/deleted',
    OrganizationDeleted = 'organization/deleted',
    TranslationSpeechDone = 'translation/speech-done',
    TranslationSpeechFailed = 'translation/speech-error',
    TranslationGroupPartialDone = 'translation/group-partial-done',
    TranslationGroupPostDone = 'translation/group-post-done',
    TranslationPostDone = 'translation/post-done',
    TranslationPostFailed = 'translation/post-error',
    TranslationGroupPostError = 'translation/group-post-error',
    SceneAvatarPostFailed = 'scene/avatar-post-error',
    SceneAvatarPostDone = 'scene/avatar-post-done',
    ProjectDone = 'project/done',
    ProjectError = 'project/error',
}
